import FieldFormatter from "../Records/Formatters/FieldFormatter";
import RecordNameCell from "../Records/RecordNameCell";
import FieldUtils from "../../utils/FieldUtils";
import useModule from "../../hooks/useModule";

/**
 * TableField - HOC for displaying Fields in AppTable.
 *
 * @param {object} fieldMap - Map of fieldAPINames -> fields for quick lookups
 * @param {object} item - The React Table, table item.
 * @param {string?} imageField - The APIName of the field to be used as the _RecordName image
 * @param {string?} imageFieldPresentation - The way the imageField should be presented ("Avatar" or "Logo")
 * @param {} reusableViews - An Object
 */
const TableField = ({
  fieldMap,
  item,
  subitemParentID,
  onOpenRecordName,
  imageField,
  imageFieldPresentation,
  metadataField,
  metadataFieldType,
  parentRecord,
  isDrawer,
  createMode = false,
  onChangeCreate,
  defaultRecordLayout,
  commentsWidget = true,
  recordNameField,
  recordNameEmpty,
  reusableViews,
}) => {
  /* const fieldMap = fieldMapRef.current; */
  const { getModule } = useModule();
  const fieldAPIName = item.column.id;
  const isLookUp = fieldAPIName.split(".")[1] ? true : false;
  const lookUpReference = isLookUp ? fieldAPIName.split(".")[0] : undefined;
  const lookUpModule = isLookUp
    ? getModule(item.row.original[lookUpReference]?._ModuleAPIName)
    : undefined;

  const lookUpField = isLookUp ? fieldAPIName.split(".")[1] : undefined;
  const field = isLookUp
    ? FieldUtils.getFieldFromModule(lookUpModule, lookUpField)
    : fieldMap[fieldAPIName];

  let value;

  const getLookUp = () => {
    const lookUpReference = fieldAPIName.split(".")[0];
    const lookUpField = fieldAPIName.split(".")[1];

    if (
      !lookUpReference ||
      !lookUpField ||
      field.SubitemParent ||
      (!item.row.original?.[lookUpReference]?.hasOwnProperty(lookUpField) &&
        item.row.original?.[lookUpReference] !== null)
    ) {
      return null;
    }

    return {
      ID: item.row.original[lookUpReference]?.id || "No ID",
      ModuleAPIName:
        item.row.original[lookUpReference]?._ModuleAPIName || "No APIName",
    };
  };

  try {
    value = item.getValue();
  } catch {}

  const record = item.row.original;

  if (!field) return null;

  // Handle Record Name
  if (fieldAPIName === "_RecordName") {
    return (
      <RecordNameCell
        record={item.row.original}
        defaultRecordLayout={defaultRecordLayout}
        onOpen={
          onOpenRecordName
            ? (module, record) => {
                onOpenRecordName({
                  recordID: record?._id || record?.id,
                  moduleAPIName: module?.APIName,
                  tab: reusableViews?.RecordDetail
                    ? `Reuse-${reusableViews?.RecordDetail}-Summary`
                    : "Summary",
                  record,
                });
              }
            : null
        }
        disableViewRecord={onOpenRecordName ? true : false}
        imageField={imageField}
        imageFieldPresentation={imageFieldPresentation}
        metadataField={metadataField}
        metadataFieldType={metadataFieldType}
        commentsWidget={commentsWidget}
        nameField={recordNameField}
        emptyText={recordNameEmpty}
      />
    );
  }

  // Handle All Other Fields
  return (
    <FieldFormatter
      key={`${fieldAPIName}-${record.id}`}
      field={field}
      value={value}
      record={record}
      recordID={record.id || record._id}
      moduleAPIName={record._ModuleAPIName}
      table={true}
      subitemParentID={subitemParentID}
      multiSubitemID={subitemParentID ? record?.id : null}
      lookUpID={getLookUp()?.ID}
      lookUpModuleAPIName={getLookUp()?.ModuleAPIName}
      lookUpField={fieldAPIName.split(".")[0]}
      parentRecord={parentRecord}
      isDrawer={isDrawer}
      createMode={createMode}
      onChangeCreate={onChangeCreate}
      reusableViewReferenceFields={reusableViews?.ReferenceFields ?? {}}
    />
  );
};

export default TableField;
